export const getProjectIdFromUrl = (): string | undefined => {
  if (typeof window === "undefined") {
    return;
  }

  const projectIdMatch = /\/opportunity\/(\d+)/.exec(window.location.pathname);
  return projectIdMatch?.[1];
};
